import { just } from 'maybeasy';
import { observer } from 'mobx-react';
import { emptyFragment } from '../../../../../../../EmptyFragment';
import { findLink } from '../../../../../../../LinkyLinky';
import LearningCollectionEditStore from '../../../../Edit/Store';
import { Section } from '../../../../Types';
import Display from './Display';

interface Props {
  store: LearningCollectionEditStore;
  section: Section;
}

function DestroySection({ store, section }: Props) {
  return just(section.resource.links)
    .andThen(findLink('delete'))
    .map((link) => <Display store={store} section={section} link={link} />)
    .getOrElse(emptyFragment);
}

export default observer(DestroySection);
